import React from 'react';
import PropTypes from 'prop-types';

// functional components(pure components) with destructuring, implicit return and default value
const LastArticlesItem = ({
	Id,
	title,
	DateIT,
	Type,
	NiceUrl,
}) => (
	<li className="single-content-art">
		<h4 className="wH3">ARTICOLO</h4>
		<br />
		<h5 className="wH4">{DateIT}</h5>
		<br />
		<p className="wP">
			<a href={`/Contenuti/Articoli/Articolo/${Id}/${NiceUrl}`} title={title}>{title}</a>
		</p>
		{Type ? <span>{Type}</span> : null}
		<hr className="wHr" />
	</li>
);

LastArticlesItem.propTypes = {
	Id: PropTypes.number.isRequired,
	title: PropTypes.string,
	// shortDescription: PropTypes.string.isRequired,
	DateIT: PropTypes.string.isRequired,
	// ImmagineMedia: PropTypes.string.isRequired,
	Type: PropTypes.string,
	NiceUrl: PropTypes.string,
};

LastArticlesItem.defaultProps = {
	title: '',
	Type: '',
	NiceUrl: '',
};

export default LastArticlesItem;
